import { createFileRoute } from '@tanstack/react-router';
import { IconSitemap } from '@tabler/icons-react';
import { ResourceListPage } from '@/shared/components/ResourceListPage';
import { QuickCreateButton, type FieldDef } from '@/shared/components/QuickCreateButton';
import type { Denormalized } from '@/shared/api/jsonapi/parser';

interface Area extends Denormalized {
  type: 'erp-business-areas';
  code?: string;
  name?: string;
  description?: string;
  sortOrder?: number;
  isActive?: boolean;
}

const FIELDS: FieldDef[] = [
  { name: 'code', label: 'Codice', required: true },
  { name: 'name', label: 'Nome', required: true },
  { name: 'description', label: 'Descrizione', kind: 'textarea' },
  { name: 'isCrossSite', label: 'Trasversale alle sedi', kind: 'boolean', defaultValue: false },
  { name: 'annualBudget', label: 'Budget annuo €', kind: 'number' },
  { name: 'kpiObjectives', label: 'Obiettivi / KPI', kind: 'textarea' },
  { name: 'sortOrder', label: 'Ordinamento', kind: 'number', defaultValue: 0 },
  { name: 'isActive', label: 'Attiva', kind: 'boolean', defaultValue: true },
];

export const Route = createFileRoute('/_app/workforce/areas')({ component: AreasPage });

function AreasPage() {
  return (
    <ResourceListPage<Area>
      title=""
      type="erp-business-areas"
      columns={[
        { accessorKey: 'code', header: 'Codice', size: 110 },
        { accessorKey: 'name', header: 'Area' },
        { accessorKey: 'description', header: 'Descrizione' },
        { accessorKey: 'isActive', header: 'Attiva', size: 90, Cell: ({ cell }) => (cell.getValue<boolean>() ? '✓' : '—') },
      ]}
      searchField="name"
      emptyMessage="Nessuna area aziendale"
      emptyDescription="Crea la prima area con il bottone «Nuova area» nella toolbar."
      emptyIcon={IconSitemap}
      editFields={FIELDS}
      editTitle="Modifica area"
      enableDelete
      getRowLabel={(r) => r.name ?? r.code ?? r.id}
      toolbarRight={<QuickCreateButton type="erp-business-areas" title="Nuova area" fields={FIELDS} />}
    />
  );
}
